/**
 * 主题预定义文件
 */
import dark from './dark'

export default {
  dark,
}
